import { GeoAddressComponent, GeoBounds, GeoGeometry, GeoLocation, GeoNortheast, GeoSouthwest, GeoViewport, GeoPhoto } from './google-geo-classes';

export class GeoData {
    address_components: GeoAddressComponent[];
    formatted_address: string;
    geometry: GeoGeometry;
    place_id: string;
    types: string[];
    adr_address: string;
    icon: string;
    id: string;
    name: string;
    photos: GeoPhoto[];
    reference: string;
    scope: string;
    url: string;
    utc_offset: number;
    vicinity: string;
    html_attributions: any[];

    constructor(data: any) {
        if (data.address_components) this.address_components = data.address_components;
        if (data.formatted_address) this.formatted_address = data.formatted_address;
        if (data.geometry) this.geometry = data.geometry;
        if (data.place_id) this.place_id = data.place_id;
        if (data.types) this.types = data.types;
        if (data.adr_address) this.adr_address = data.adr_address;
        if (data.icon) this.icon = data.icon;
        if (data.id) this.id = data.id;
        if (data.name) this.name = data.name;
        if (data.photos) this.photos = data.photos;
        if (data.reference) this.reference = data.reference;
        if (data.scope) this.scope = data.scope;
        if (data.url) this.url = data.url;
        if (data.utc_offset) this.utc_offset = data.utc_offset;
        if (data.vicinity) this.vicinity = data.vicinity;
        if (data.html_attributions) this.html_attributions = data.html_attributions;
    }

    getAddressComponent(type: string): GeoAddressComponent {
        let output = new GeoAddressComponent();
        if (this.address_components) output = this.address_components.find(x => x.types.indexOf(type) > -1);;
        return output;
    }
    getLocalita(): GeoAddressComponent {
        return this.getAddressComponent("locality");
    }
    getComune(): GeoAddressComponent {
        return this.getAddressComponent("administrative_area_level_3");
    }
    getProvincia(): GeoAddressComponent {
        return this.getAddressComponent("administrative_area_level_2");
    }
    getRegione(): GeoAddressComponent {
        return this.getAddressComponent("administrative_area_level_1");
    }
    getNazione(): GeoAddressComponent {
        return this.getAddressComponent("country");
    }
    getCap(): GeoAddressComponent {
        return this.getAddressComponent("postal_code");
    }
    getIndirizzo(): string {
        return this.formatted_address;
    }
    getCoordinate(): GeoLocation {
        let output: GeoLocation;
        if (this.geometry) output = this.geometry.location;
        return output;
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/models/google-geo-data.ts